// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
//let base = "http://qa-aplicaciones.mop.gob.cl:8080/API_ServiciosTramite-1.0.1/api/sv/tramite/";//testing
let base = "https://aplicaciones.mop.gob.cl/APICertificadoHonorarios/api/sv/tramite/";//produccion
export const environment = {
  production: false,
  
    represent:		base+"Existe_Represent",
	emprdet:		base+"empresa_detalle",
	insrepleg:		base+"insert_repres_legal",
	insemprrepleg:	base+"insert_empr_repres_legal",
	insempr:		base+"insert_empresa",
	lovs:			base+"listados",
	cargaarchivo:	base+"filetramites",
	urllogin:		base+"AD",
	solpendientes:	base+"Solic_Pend_File",
	getdoctos:		base+"buscadoctos",
	apruebasol:		base+"aprobar_solicitud",
	rechazosol:		base+"rechazo_solicitud",
	funcxrut:		base+"get_funcionalidades_rut",
	certdecjur: 	base+"certif_renta_honor",
	periodos:		base+"agnos_certificado_renta",
	detsolicitud:	base+"lis_nro_solicitud"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.

 
};
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
